module.exports = __webpack_public_path__ + "static/media/jaragua-capa.0f251be7.png";